import { render } from "./ContractDialog.vue?vue&type=template&id=49af9b79"
import script from "./ContractDialog.vue?vue&type=script&lang=js"
export * from "./ContractDialog.vue?vue&type=script&lang=js"
script.render = render

export default script